define.alias("ember-intl/helpers/format-message", "settings/helpers/format-message");